import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Validators, FormControl } from "@angular/forms";
import { CommonFunctionService ,UserPOSData} from "../../../../services/Common/common-function.service";
import { PaymentService } from 'src/app/POS/POSServices/Setup/payment.service';
const swal = require('sweetalert');
@Component({
  selector: 'app-payment-receipt',
  templateUrl: './payment-receipt.component.html',
  styleUrls: ['./payment-receipt.component.scss']
})
export class PaymentReceiptComponent implements OnInit {
  isviewpaymentrecipt:boolean=false;
  merchantdata: UserPOSData ;
  isNewpaymentrecipt: boolean = true;
  isUpdatepaymentrecipt: boolean = false;
  rows;
  OptInToMarketingOnEmailReceiptsContents  = new FormControl("", [Validators.required]);
  CustomHeaderText  = new FormControl("", [Validators.required]);
  CustomFooterText  = new FormControl("", [Validators.required]);
  CustomLogoForPaymentReciept  = new FormControl("", [Validators.required]);
  LineItemModifierType  = new FormControl("", [Validators.required]);

   AutoPrintCustomerReceiptAfterEachOrder :boolean=false;
   SkipPrintScriptBeginNextTransaction :boolean=false;
   MarkOrdersAsPrintedWhenPrintingBill :boolean=false;
   AllowCustomerToOptInToMarketingOnEmailReceipts :boolean=false;
   ShowBusinessLogoOnPaymentReciept :boolean=false;
   GroupItemsByGuest:boolean=false;
   OrderNotes :boolean=false;
   CashierName :boolean=false;
   LineItems:boolean=false;
   OnlineReceiptUrl:boolean=false;
   BarCode :boolean=false;
   Customerinfo :boolean=false;
    employeeId= new FormControl("", [Validators.required]);
  Id= new FormControl("", [Validators.required]);
  constructor(
    private router: Router,
    private commonfunction: CommonFunctionService,
    private service: PaymentService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.merchantdata = this.commonfunction.getUserPOSData();
    this.getGetpaymentreciptDetails();
  }
  getGetpaymentreciptDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
     form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

    this.service.GetPaymentReceiptDetail(form).subscribe(result => {   
      console.log("result.Id---" + result);
      if (result.id > 0) {
        this.AutoPrintCustomerReceiptAfterEachOrder  =result.autoPrintCustomerReceiptAfterEachOrder  ;
        this.SkipPrintScriptBeginNextTransaction  = result.skipPrintScriptBeginNextTransaction  ;   
        this.MarkOrdersAsPrintedWhenPrintingBill  = result.markOrdersAsPrintedWhenPrintingBill  ;     
        this.ShowBusinessLogoOnPaymentReciept  =result.showBusinessLogoOnPaymentReciept  ;     
        this.GroupItemsByGuest  = result.groupItemsByGuest  ;   
        this.OrderNotes  = result.orderNotes  ;    
        this.CashierName  = result.cashierName  ;     
        this.LineItems   = result.lineItems   ;    
        this.OnlineReceiptUrl  = result.onlineReceiptUrl  ;    
        this.Customerinfo  = result.customerinfo  ;
        this.BarCode  = result.barCode  ;
        this.AllowCustomerToOptInToMarketingOnEmailReceipts  = result.allowCustomerToOptInToMarketingOnEmailReceipts  ; 
       this.isviewpaymentrecipt=true
        this.isUpdatepaymentrecipt = false;
        this.isNewpaymentrecipt = false;
        this.rows = result;
      } else {
        this.isUpdatepaymentrecipt = false;
        this.isNewpaymentrecipt = true;
        this.isviewpaymentrecipt=false;
      }
    });
 
  }
  paymentrecipt() {
    let form = {
      PosSubscriptionId: "",
    EmployeeId : "",
    OptInToMarketingOnEmailReceiptsContents  : "",
    CustomHeaderText  : "",
    CustomFooterText  : "",
    CustomLogoForPaymentReciept  : "",
    LineItemModifierType  : "",
    AutoPrintCustomerReceiptAfterEachOrder  :false,
    SkipPrintScriptBeginNextTransaction :false,
    MarkOrdersAsPrintedWhenPrintingBill  :false,
    AllowCustomerToOptInToMarketingOnEmailReceipts :false,
    ShowBusinessLogoOnPaymentReciept  :false,
    GroupItemsByGuest :false,
    OrderNotes :false,
    CashierName  :false,
    LineItems :false,
    OnlineReceiptUrl :false,
    BarCode  :false,
    Customerinfo  :false,
    };
    form.EmployeeId = this.employeeId.value;
    form.OptInToMarketingOnEmailReceiptsContents  = this.OptInToMarketingOnEmailReceiptsContents .value;
    form.CustomHeaderText  = this.CustomHeaderText .value;
    form.CustomFooterText  = this.CustomFooterText .value;
    form.CustomLogoForPaymentReciept  = this.CustomLogoForPaymentReciept .value;
    form.LineItemModifierType  = this.LineItemModifierType .value;
    form.AutoPrintCustomerReceiptAfterEachOrder  = this.AutoPrintCustomerReceiptAfterEachOrder;
    form.SkipPrintScriptBeginNextTransaction  = this.SkipPrintScriptBeginNextTransaction;
    form.MarkOrdersAsPrintedWhenPrintingBill  = this.MarkOrdersAsPrintedWhenPrintingBill ;
    form.AllowCustomerToOptInToMarketingOnEmailReceipts  = this.MarkOrdersAsPrintedWhenPrintingBill ;
    form.ShowBusinessLogoOnPaymentReciept  = this.ShowBusinessLogoOnPaymentReciept 
    form.GroupItemsByGuest  = this.GroupItemsByGuest;
    form.OrderNotes  = this.OrderNotes;
    form.CashierName  = this.CashierName;
    form.LineItems  = this.LineItems ;
    form.OnlineReceiptUrl  = this.OnlineReceiptUrl;
    form.BarCode  = this.BarCode;
    form.Customerinfo  = this.Customerinfo;
    // form.Address=this.address.value;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    // alert(this.requestDate.value);
    // alert(this.dueDate.value);
    this.service.AddPaymentReceipt(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {            
      //  swal("Added", "Payment Recipt Added Successfully ", "success"); 
      //   this.router.navigate(["/pos/paymentrecipt/new"]);
      this.AddRecipt();
      }
    });
  }
  AddRecipt()
  {
    swal({
      title: 'Payment Recipt Added Successfully !',
      text: '',
      icon: 'success',
      buttons: {
        
          confirm: {
              text: 'Ok',
              value: true,
              visible: true,
              className: "",
              closeModal: true
          }
      }
  }).then((isConfirm) => {
      if (isConfirm) {
      window.location.reload();
      }
    
  });
  }



  editpaymentrecipt()
  {
    this.isUpdatepaymentrecipt = true;
    this.isNewpaymentrecipt = false;
    this.isviewpaymentrecipt=false;
  }
  updatepaymentrecipt()
  {
    let form = {
        PosSubscriptionId: "",
    EmployeeId : "",
    OptInToMarketingOnEmailReceiptsContents  : "",
    CustomHeaderText  : "",
    CustomFooterText  : "",
    CustomLogoForPaymentReciept  : "",
    LineItemModifierType  : "",
    AutoPrintCustomerReceiptAfterEachOrder  :false,
    SkipPrintScriptBeginNextTransaction :false,
    MarkOrdersAsPrintedWhenPrintingBill  :false,
    AllowCustomerToOptInToMarketingOnEmailReceipts :false,
    ShowBusinessLogoOnPaymentReciept  :false,
    GroupItemsByGuest :false,
    OrderNotes :false,
    CashierName  :false,
    LineItems :false,
    OnlineReceiptUrl :false,
    BarCode  :false,
    Customerinfo  :false,
    Id:"",
    };
    form.EmployeeId = this.employeeId.value;
    form.OptInToMarketingOnEmailReceiptsContents = this.OptInToMarketingOnEmailReceiptsContents.value;
    form.CustomHeaderText = this.CustomHeaderText.value;
    form.CustomFooterText = this.CustomFooterText.value;
    form.CustomLogoForPaymentReciept = this.CustomLogoForPaymentReciept.value;
    form.LineItemModifierType = this.LineItemModifierType.value;
    form.AutoPrintCustomerReceiptAfterEachOrder  = this.AutoPrintCustomerReceiptAfterEachOrder;
    form.SkipPrintScriptBeginNextTransaction  = this.SkipPrintScriptBeginNextTransaction;
    form.MarkOrdersAsPrintedWhenPrintingBill  = this.MarkOrdersAsPrintedWhenPrintingBill ;
    form.AllowCustomerToOptInToMarketingOnEmailReceipts  = this.AllowCustomerToOptInToMarketingOnEmailReceipts ;
    form.ShowBusinessLogoOnPaymentReciept  = this.ShowBusinessLogoOnPaymentReciept 
    form.GroupItemsByGuest  = this.GroupItemsByGuest;
    form.OrderNotes  = this.OrderNotes;
    form.CashierName  = this.CashierName;
    form.LineItems  = this.LineItems ;
    form.OnlineReceiptUrl  = this.OnlineReceiptUrl;
    form.BarCode  = this.BarCode;
    form.Customerinfo  = this.Customerinfo;
    // form.Address=this.address.value;
  //  form.Id=this.rows.id;
  form.Id=this.Id.value;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    // alert(this.requestDate.value);
    // alert(this.dueDate.value);
    this.service.UpdateOrderReceipt(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
     
        // swal("Added", "Payment recipt Updated Successfully ", "success"); 
        // this.router.navigate(["/pos/paymentrecipt/new"]);
        this.updaterecipt()
      }
    });
  }
  updaterecipt()
  {
    swal({
      title: 'Payment recipt Updated Successfully !',
      text: '',
      icon: 'success',
      buttons: {
        
          confirm: {
              text: 'Ok',
              value: true,
              visible: true,
              className: "",
              closeModal: true
          }
      }
  }).then((isConfirm) => {
      if (isConfirm) {
      window.location.reload();
      }
    
  });
  }



  CustomerReceipt()
  {
    this.AutoPrintCustomerReceiptAfterEachOrder  = !this.AutoPrintCustomerReceiptAfterEachOrder  ;
  }
  SkipPrint()
  {
    this.SkipPrintScriptBeginNextTransaction  = !this.SkipPrintScriptBeginNextTransaction  ;
  }
  PrintingBill()
  {
    this.MarkOrdersAsPrintedWhenPrintingBill  = !this.MarkOrdersAsPrintedWhenPrintingBill  ;
  }
  EmailReceipts()
  {
    this.AllowCustomerToOptInToMarketingOnEmailReceipts  = !this.AllowCustomerToOptInToMarketingOnEmailReceipts  ;
  }
  PaymentReciept()
  {
    this.ShowBusinessLogoOnPaymentReciept  = !this.ShowBusinessLogoOnPaymentReciept  ;
  }
  GroupItems()
  {
    this.GroupItemsByGuest  = !this.GroupItemsByGuest  ;
  }
  OrderNotes1()
  {
    this.OrderNotes  = !this.OrderNotes  ;
  }
  CashierName1()
  {
    this.CashierName  = !this.CashierName  ;
  }
  LineItems1()
  {
    this.LineItems   = !this.LineItems   ;
  }
  OnlineReceiptUrl1()
  {
    this.OnlineReceiptUrl  = !this.OnlineReceiptUrl  ;
  }
  BarCode1()
  {
    this.BarCode  = !this.BarCode  ;
  }
  Customerinfo1()
  {
    this.Customerinfo  = !this.Customerinfo  ;
  }

  

  OptInToMarketingOnEmailReceiptsContentsError() {
     return this.OptInToMarketingOnEmailReceiptsContents.hasError("required") ? "OptInToMarketingOnEmailReceiptsContents is required"
       : this.OptInToMarketingOnEmailReceiptsContents.hasError("pattern") ? "OptInToMarketingOnEmailReceiptsContents should be allow only alphabets" : "";
  }
  CustomHeaderTextError() {
    return this.CustomHeaderText.hasError("required") ? "CustomHeaderText is required"
      : this.CustomHeaderText.hasError("pattern") ? "CustomHeaderText should be allow only alphabets" : "";
 }
 CustomFooterTextError() {
  return this.CustomFooterText.hasError("required") ? "CustomFooterText is required"
    : this.CustomFooterText.hasError("pattern") ? "CustomFooterText should be allow only alphabets" : "";
}
CustomLogoForPaymentRecieptError() {
  return this.CustomLogoForPaymentReciept.hasError("required") ? "CustomLogoForPaymentReciept is required"
    : this.CustomLogoForPaymentReciept.hasError("pattern") ? "CustomLogoForPaymentReciept alphabets" : "";
}


}
